import {
  GuideTargetPivotedRowDto,
  GuideTargetsClientRevenueDto,
  GuideTargetTotalByTypeDto,
  GuideTargetTypeDto,
  ServiceAreaDto,
} from '@act/shared/data-transfer-objects';

export interface GuideTargetsFiltersType {
  clientIds: string[];
  guideIds: string[];
  targetTypeKeys: string[];
  serviceAreaKeys: string[];
}

export function defaultGuideTargetsFilters(): GuideTargetsFiltersType {
  return {
    clientIds: [],
    guideIds: [],
    targetTypeKeys: [],
    serviceAreaKeys: [],
  };
}

export interface GuideTargetsState {
  status: 'failed' | 'initial' | 'loading' | 'success';
  /** Only the latest list request may commit results — avoids out-of-order responses overwriting data. */
  latestPagedGuideTargetsRequestId: string | null;
  items: GuideTargetPivotedRowDto[];
  count: number;
  targetTypeKeys: string[];
  totalQueued: number;
  totalsByTargetType: GuideTargetTotalByTypeDto[];
  filters: GuideTargetsFiltersType;
  sideNavClientId: string | null;
  selectedYearMo: number | null;
  availablePeriodsStatus: 'failed' | 'initial' | 'loading' | 'success';
  availableYearMoValues: number[];
  targetsUpdated: number;
  targetTypes: GuideTargetTypeDto[];
  serviceAreas: ServiceAreaDto[];
  targetTypesStatus: 'failed' | 'initial' | 'loading' | 'success';
  serviceAreasStatus: 'failed' | 'initial' | 'loading' | 'success';
  clientRevenue: GuideTargetsClientRevenueDto | null;
}
